import React from 'react';
import {bool, object} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import {Container, Icon, Label, Table} from 'semantic-ui-react';
import {formatDate} from 'utils/DBUtils';
import FailureDisplay from './FailureDisplay';
import {dateTimeFormatString, formatDateTime, userIsAdmin} from '../../utils';
import {MultiGroupDropdown} from "../../../../components/composites/UserGroupDropdown";

const Row = props => (
  <Table.Row>
    <Table.Cell>
      <strong>{props.label}</strong>
    </Table.Cell>
    <Table.Cell>
      {props.value}
    </Table.Cell>
  </Table.Row>
);

const mapGroupIds = (user) => {
    let list = user.userProfile.partnerGroups || [];
    return list.map((partnerGroup) => partnerGroup.groupId)
};

const UserOverviewPage = props => {
  if (props.isLoading) {
    return (
      <Container textAlign='center'>
        <Icon loading name='spinner' size='huge' />
      </Container>
    );
  }

  if (props.ajaxError) {
    return <FailureDisplay labelKey='userManagement.userDetail.panes.overview.ajaxError' />;
  }

  // only have one group per user right now
    let group = mapGroupIds(props.user)[0];

  return !isEmpty(props.user) && (
    <Table striped celled className='fadeInUp animResponse'>
      <Table.Body>
          {userIsAdmin(props.loggedInUser) ? (
              <Row label={<FormattedMessage id='userManagement.userDetail.panes.overview.group'/>}
                   value={(
                       <MultiGroupDropdown selection
                                           placeholder="Groups"
                                           onValueChanged={props.saveUserGroups}
                                           value={group}/>
                   )}/>
          ) : ""}
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.createdOn' />}
          value={(
            <span>
              {formatDate(props.user.createdOn * 1000, dateTimeFormatString)}
              {props.user.deleted && (
                <Label className='db-label-inline db-label-danger'>
                  <FormattedMessage id='userManagement.userDetail.panes.overview.createdOn.deleted' />
                </Label>
              )}
            </span>
          )} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.email' />}
          value={(
            <span>
              {props.user.email}
              {props.user.guest ? null : props.user.emailPref === 'none' ? (
                <Label className='db-label-inline db-label-danger'>
                  <FormattedMessage id='userManagement.userDetail.panes.overview.email.unsubscribed' />
                </Label>
              ) : (
                <Label className='db-label-inline db-label-success'>
                  <FormattedMessage id='userManagement.userDetail.panes.overview.email.subscribed' />
                </Label>
              )}
            </span>
          )} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.firstName' />}
          value={props.user.firstName} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.lastName' />}
          value={props.user.lastName} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.age' />}
          value={props.user.age} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.gender' />}
          value={props.user.gender} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.birthday' />}
          value={props.user.birthday ? formatDate(props.user.birthday, "MM/DD/YYYY") : ''} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.city' />}
          value={props.user.city} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.state' />}
          value={props.user.state} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.zipCode' />}
          value={props.user.zipCode} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.lastLogin' />}
          value={formatDate(props.user.lastLogin * 1000, dateTimeFormatString)} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.emailPref' />}
          value={props.user.emailPref || 'Emails allowed'} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.level' />}
          value={props.user.level.level} />
        <Row
          label="Consecutive Days on Site"
          value={props.user.userProfile.consecutiveDaysOnSite} />

        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.lastEmailUpdate' />}
          value={props.user.lastEmailUpdate ? formatDateTime(props.user.lastEmailUpdate) : (
            <Label className='db-label-warning'>
              <FormattedMessage id='userManagement.userDetail.panes.overview.lastEmailUpdate.none' />
            </Label>
          )} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.deleted' />}
          value={String(props.user.deleted)} />
        <Row
          label={<FormattedMessage id='userManagement.userDetail.panes.overview.regIpAddress' />}
          value={props.user.regIpAddress} />
      </Table.Body>
    </Table>
  );
};

UserOverviewPage.propTypes = {
  user: object.isRequired,
  isLoading: bool.isRequired,
  ajaxError: object
};

export default UserOverviewPage;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserOverviewPage.jsx